import IncidentsAndSafetyAlerts from '../pages/governance/IncidentsAndSafetyAlerts'
import MedicinesManagement from '../pages/governance/MedicinesManagement'
import PoliciesAndSOPs from '../pages/governance/PoliciesAndSOPs'
import PGDLibrary from '../pages/governance/PGDLibrary'
import GovernanceAudits from '../pages/governance/GovernanceAudits'
import RiskRegister from '../pages/governance/RiskRegister'
import KPITracker from '../pages/governance/KPITracker'
import MeetingsAndAnnouncements from '../pages/governance/MeetingsAndAnnouncements'
import CqcCentreOverview from '../pages/governance/CqcCentreOverview'
import CqcEvidenceGapsActions from '../pages/governance/CqcEvidenceGapsActions'
import CqcRegistrationCentre from '../pages/governance/CqcRegistrationCentre'
import FreedomToSpeakUp from '../pages/governance/FreedomToSpeakUp'
import GovernanceActionsDoc from '../pages/governance/GovernanceActionsDoc'

export default [
  {
    id: 'incidents-and-safety',
    title: 'Incidents and Safety',
    pages: [
      {
        id: 'incidents-and-safety-alerts',
        title: 'Incidents and Safety Alerts',
        summary:
          'Report incidents through the eight-step wizard, investigate them with review-time detail corrections, people involved, witness statements (including secure links for external witnesses), corrective actions, and a full history tab, review automatic MHRA safety alerts, and find patient/event feedback review.',
        component: IncidentsAndSafetyAlerts,
        tags: [
          'Incidents',
          'Safety Alerts',
          'Report Incident',
          'External Witness',
          'Witness Link',
          'Awaiting Witness',
          'Witness Statements',
          'Corrective Actions',
          'People Involved',
          'Staff Welfare',
          'Investigation',
          'MHRA',
          'Duty of Candour',
        ],
      },
      {
        id: 'freedom-to-speak-up',
        title: 'Freedom to Speak Up',
        summary:
          'Anonymous-by-default concern raising, separate from incident reporting: staff raise concerns at Speak Up, Governance reviews them through New, Under Review, and Closed, and organisations can opt out in Site Config.',
        component: FreedomToSpeakUp,
        tags: [
          'Speak Up',
          'Freedom to Speak Up',
          'Concerns',
          'Anonymous',
          'Whistleblowing',
          'Patient Safety',
        ],
      },
    ],
  },
  {
    id: 'medicines',
    title: 'Medicines',
    pages: [
      {
        id: 'medicines-management',
        title: 'Medicines Management',
        summary:
          'Medicine formulary, stores, drug bags, bag levels, custom alarms, bag checks, the medicine drawer with reasoned stock removal, drawn-up medicines, administration records with corrections/voids, incident medicine reporting, the controlled drug register with running balances, two-mode CD audits, seal scanning, discrepancy investigations, and the weekly expiry digest.',
        component: MedicinesManagement,
        tags: [
          'Medicines',
          'Formulary',
          'Drug Bags',
          'Bag Levels',
          'Custom Alarms',
          'Administration',
          'Controlled Drugs',
          'CD Register',
          'Discrepancies',
          'Seal Scanning',
          'Drawn-up Medicines',
          'Stock Removal',
          'Expiry Digest',
          'CD Audit',
          'Medicine Drawer',
          'Corrections',
          'Void',
        ],
      },
    ],
  },
  {
    id: 'policies-sops-pgds',
    title: 'Policies, SOPs, and PGDs',
    pages: [
      {
        id: 'policies-and-sops',
        title: 'Policies and SOPs',
        summary:
          'Browse policies (PDF-only, open-before-acknowledge) and SOPs (PDF or video) with versioning, review dates, mark-as-read acknowledgements, and governance review tracking.',
        component: PoliciesAndSOPs,
        tags: ['Policies', 'SOPs', 'Guidelines', 'PDF', 'Video SOPs', 'Mark as Read'],
      },
      {
        id: 'pgd-library',
        title: 'PGD Library',
        summary:
          'Access, version, and sign Patient Group Directions - signing requires a password re-entry, and review dates control what staff can see.',
        component: PGDLibrary,
        tags: ['PGD', 'Patient Group Direction', 'Signatures', 'Review Date'],
      },
    ],
  },
  {
    id: 'audits-risk-kpis',
    title: 'Audits, Risk, and KPIs',
    pages: [
      {
        id: 'governance-audits',
        title: 'Governance Audits',
        summary:
          'Build audit templates with guided questions, complete audits that raise follow-up actions, and review the audit log.',
        component: GovernanceAudits,
        tags: ['Audits', 'Audit Templates', 'Audit Log', 'Actions'],
      },
      {
        id: 'governance-actions',
        title: 'Governance Actions',
        summary:
          'The register of follow-up actions raised by audits, incidents, meetings, risks, complaints, KPI reviews, and the CQC Centre - with due dates, priorities, completion notes, evidence files, and how actions differ from CQC gaps.',
        component: GovernanceActionsDoc,
        tags: [
          'Governance Actions',
          'Actions Register',
          'Overdue',
          'Completion Notes',
          'Evidence',
          'CQC Gaps',
        ],
      },
      {
        id: 'risk-register',
        title: 'Risk Register',
        summary:
          'Track organisational risks scored by likelihood and consequence with initial, current, and target RAG ratings, on an annual review cycle that feeds the CQC Centre.',
        component: RiskRegister,
        tags: [
          'Risk Register',
          'RAG',
          'Likelihood',
          'Consequence',
          'Mitigation',
          'Annual Review',
        ],
      },
      {
        id: 'kpi-tracker',
        title: 'KPI Tracker',
        summary:
          'Live auto-computed KPI dashboards across ten domains including Finance, with per-organisation targets, drill-down tiles, shareable date-range URLs, and overview and per-section PDF reports.',
        component: KPITracker,
        tags: [
          'KPI',
          'Dashboards',
          'Metrics',
          'Targets',
          'Finance',
          'Analytics',
          'PDF Report',
          'Drill-down',
        ],
      },
    ],
  },
  {
    id: 'cqc-centre',
    title: 'CQC Centre',
    pages: [
      {
        id: 'cqc-centre-overview',
        title: 'CQC Centre Overview',
        summary:
          'Inspection-readiness self-assessment: overall and per-key-question scores, quality statements, compliance questions, settings, and the exportable Inspection Pack.',
        component: CqcCentreOverview,
        tags: [
          'CQC',
          'Inspection Readiness',
          'Key Questions',
          'Quality Statements',
          'Compliance Questions',
          'Inspection Pack',
          'Readiness Score',
        ],
      },
      {
        id: 'cqc-evidence-gaps-actions',
        title: 'Evidence, Gaps, and Assignments',
        summary:
          'Automatically collected evidence with expiry tracking, gap severities, fix-it deep links, and one-click assignment of gaps to the person who will fix them. Gaps cannot be dismissed.',
        component: CqcEvidenceGapsActions,
        tags: [
          'CQC',
          'Evidence Library',
          'Gaps',
          'Assign',
          'Mark Reviewed',
          'Fix It Links',
        ],
      },
      {
        id: 'cqc-registration-centre',
        title: 'Registration Centre',
        summary:
          'Regulated activities and registration status, per-event CQC exposure assessments, the Statement of Purpose builder, and 6 December 2027 deadline alerts.',
        component: CqcRegistrationCentre,
        tags: [
          'CQC Registration',
          'Regulated Activities',
          'Exposure Assessment',
          'Statement of Purpose',
          '2027 Deadline',
        ],
      },
    ],
  },
  {
    id: 'meetings-and-announcements',
    title: 'Meetings and Announcements',
    pages: [
      {
        id: 'meetings-and-announcements',
        title: 'Meetings and Announcements',
        summary:
          'Governance meetings with typed agendas (item leads, CQC tags, estimated times, and completion) and meeting notes, plus organisation-wide announcements with acknowledgement tracking.',
        component: MeetingsAndAnnouncements,
        tags: [
          'Meetings',
          'Announcements',
          'Agenda',
          'Meeting Notes',
          'Meeting Type',
          'Acknowledgement',
        ],
      },
    ],
  },
]
